import { useMutation } from "@tanstack/react-query";
import type { components } from "@/shared/lib/api.types";
import { api, unwrap } from "@/shared/lib/apiClient";

type ChangePasswordRequest = components["schemas"]["ChangePasswordRequest"];

// The backend re-issues this session's cookie (current session survives, other devices log out);
// nothing to invalidate.
export function useChangePassword() {
  return useMutation({
    mutationFn: async (body: ChangePasswordRequest) =>
      unwrap(await api.POST("/api/auth/change-password", { body })),
  });
}
